import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Elements
import { ModalBodyWrapper } from './UpdateTransferModal.elements'

// Views
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function UpdateTransferModal(props) {
  // Destructure
  const { ui, actions } = props

  // Store State
  const { isUpdateTransferModalOpen, updateTransferModalData } = ui

  // Store Actions
  const { toggleUpdateTransferModal, setUpdateTransferModalStatus, setUpdateTransferModalData } = actions

  // Functions
  const cancel = () => {
    toggleUpdateTransferModal()
    setUpdateTransferModalStatus()
    setUpdateTransferModalData()
  }
  const handleConfirm = () => {
    setUpdateTransferModalStatus({ confirmed: true })
    toggleUpdateTransferModal()
  }

  // UseEffect
  useEffect(() => {}, [])
  return (
    <Modal isOpen={isUpdateTransferModalOpen} toggle={cancel}>
      <ModalHeader toggle={cancel}>{updateTransferModalData?.title}</ModalHeader>
      <ModalBody>
        <ModalBodyWrapper>{updateTransferModalData?.content}</ModalBodyWrapper>
      </ModalBody>
      <ModalFooter>
        <Button fullWidth onClick={cancel} type="button" variant="outlined">
          Cancel
        </Button>

        <Button fullWidth onClick={handleConfirm} type="button" color="secondary">
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  )
}

// Default Props
UpdateTransferModal.defaultProps = {
  ui: {},
  form: {},
  actions: {},
}

// Proptypes Validation
UpdateTransferModal.propTypes = {
  ui: PropTypes.shape({
    isUpdateTransferModalOpen: PropTypes.bool,
    updateTransferModalStatus: PropTypes.shape({ confirmed: PropTypes.bool }),
    updateTransferModalData: PropTypes.shape({ title: PropTypes.string, content: PropTypes.string }),
  }),
  form: PropTypes.shape({
    activityToRemove: PropTypes.shape({
      type: PropTypes.string,
      hash: PropTypes.string,
    }),
  }),
  address: PropTypes.shape({
    addressRemove: PropTypes.shape({ address_id: PropTypes.string }),
  }),
  actions: PropTypes.shape({
    toggleUpdateTransferModal: PropTypes.func,
    setUpdateTransferModalStatus: PropTypes.func,
    setUpdateTransferModalData: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTransferModal)
